import { AvatarProps } from 'antd';
import { flow, fromPairs, map } from 'lodash/fp';
import { FC } from 'react';

import InitialsAvatar from '../InitialsAvatar';
import SystemAvatar from '../SystemAvatar';
import { useUsers } from '../UsersProvider';

type UserAvatarProps = AvatarProps & {
  userId: string;
  tooltip?: boolean;
};

const UserAvatar: FC<UserAvatarProps> = ({ userId, ...rest }) => {
  const users = useUsers();
  const userNames = flow(
    map(
      ({ id, firstName, lastName }) =>
        [id, `${firstName} ${lastName}`] as string[],
    ),
    fromPairs,
  )(users);

  if (userNames[userId]) {
    return <InitialsAvatar {...rest}>{userNames[userId]}</InitialsAvatar>;
  }

  return <SystemAvatar {...rest} />;
};

UserAvatar.displayName = 'UserAvatar';

export default UserAvatar;
